import "./InfoButton.scss"

import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import iconInfo from "assets/img/icon-info.svg"

import Tooltip from "components/Tooltip/Tooltip"

interface IInfoButtonProps {
    onClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void
    withoutTooltip?:boolean
}

const InfoButton: FunctionComponent<React.PropsWithChildren<IInfoButtonProps>> = ({
    onClick,
    withoutTooltip
}) => {
    const { t } = useTranslation()

    function handleClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.stopPropagation()
        e.preventDefault()
        onClick(e)
    }

    return (
        <Tooltip
            trigger="hover"
            content={ withoutTooltip ? undefined : t('common.showDetails')}>
            <button
                type="button"
                className="info-button"
                aria-label={t('common.showDetails')}
                onClick={handleClick}
                data-testid="info-button">
                <img src={iconInfo} alt="" />
            </button>
        </Tooltip>
    )
}

export default InfoButton
